import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'components';
import debounce from 'lodash/debounce';
import { getForwardGeocodingURL, formatLocationSearchResponse } from 'utils/mapbox';
import { handleError } from 'utils/errorHandler';

const DEBOUNCE_MS = 500;

const LocationSearch = ({ countryCode, onLocationClick, listCollapse, onLocationInputClick }) => {
  const [locationField, setLocationField] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [locationList, setLocationList] = useState([]);
  const [isListCollapse, setIsListCollapse] = useState(listCollapse);

  const fetchLocation = async searchField => {
    try {
      const countryCodeLowerCase = countryCode.toLowerCase();
      const url = getForwardGeocodingURL(searchField, countryCodeLowerCase);
      const res = await fetch(url);
      const searchResponse = await res.json();
      setLocationList(formatLocationSearchResponse(searchResponse.features));
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsListCollapse(listCollapse);
  }, [listCollapse]);

  const debounceLocationRequest = useCallback(
    debounce(value => fetchLocation(value), DEBOUNCE_MS),
    []
  );

  const onLocationInputChange = e => {
    const value = e.currentTarget.value;
    setLocationField(value);
    setLocationList([]);
    if (value.trim() === '') {
      setIsListCollapse(true);
      return;
    }
    setIsListCollapse(false);
    setIsLoading(true);
    debounceLocationRequest(value);
  };

  const onLocationClickHandler = locationInfo => {
    onLocationClick(locationInfo);
    setLocationField('');
    setLocationList([]);
  };

  return (
    <div className="mapbox-container__search">
      <Input
        placeholder="Search place"
        initialValue={locationField}
        onChange={onLocationInputChange}
        onFocus={onLocationInputClick}
      />
      <ul className="mapbox-container__location-list">
        {isLoading && (
          <div className="mapbox-container__search-loader">
            <p className="loader" />
          </div>
        )}

        {!isListCollapse &&
          locationList.map((location, index) => (
            <li
              key={index}
              className="mapbox-container__location-item"
              onClick={() => onLocationClickHandler(location)}
            >
              {location.placeName}
            </li>
          ))}
      </ul>
    </div>
  );
};

LocationSearch.propTypes = {
  countryCode: PropTypes.string,
  onLocationClick: PropTypes.func.isRequired,
  listCollapse: PropTypes.bool,
  onLocationInputClick: PropTypes.func,
};
LocationSearch.defaultProps = {
  listCollapse: false,
  countryCode: '',
};

export default LocationSearch;
